export class Analytics {
    public static sendEvent(category: string, action: string, label: string): void {
        const anyWindow = window as any;
        anyWindow.dataLayer.push({
            event: 'eventGA', // Always this value
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
        });
    }

    public static sendRawEvent(event: object) {
        const anyWindow = window as any;
        anyWindow.dataLayer.push(event);
    }
}
